import storeConstants from '@utils/constants/store';
import apiService from '@api/apiService';
import { storeUtils } from '@utils';
import LogService from '@services/LogService';

const REFRESH_TIME = storeConstants.REFRESH_TIME;

const STORE_NAME = 'productCategories';

const uniqueCategories = (data) => {
    return Array.from(new Set(data.map((a) => a.id))).map((id) => {
        return data.find((a) => a.id === id);
    });
};

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        list: [],
        timestamp: 0,
        loading: false,
        refresh: false,
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        clearList(state) {
            state.list = [];
        },
        setList(state, data) {
            state.timestamp = new Date().getTime();
            state.list = uniqueCategories(data.list);
        },
        setRefresh(state, refresh) {
            state.refresh = refresh;
        },
    },

    actions: {
        get: async ({ commit, state }, { refresh = false } = {}) => {
            const needsRefresh =
                refresh ||
                state.refresh ||
                storeUtils.isStoreOutDated(state.timestamp, REFRESH_TIME);
            if (needsRefresh) {
                commit('clearList');
                commit('setLoading', true);
                const response = await apiService.product.categories.get();
                commit('setLoading', false);

                if (response.success) {
                    commit('setList', response.data);

                    return state.list;
                } else {
                    LogService.debug('problem loading categories');
                    return false;
                }
            }
        },
        needsRefresh({ commit }) {
            commit('setRefresh', true);
        },
    },
};
